<span
  (mouseenter)="onShowTooltip($event)"
  (mouseleave)="onHideTooltip()"
  (click)="onHideTooltip()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <ng-content></ng-content>
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOffsetX]="offsetX"
  [cdkConnectedOverlayOffsetY]="offsetY"
>
  @if (!pattern) {
  <div
    class="job-detail-progressbar-container"
    [style.top]="loadingPos.top"
    [style.left]="loadingPos.left"
  >
    <mat-spinner
      class="job-detail-progressbar"
      diameter="40"
    ></mat-spinner>
  </div>
  } @else {
  <div
    class="jobDetailTooltip tooltip-show"
    (mouseenter)="onShowTooltip1()"
    (mouseleave)="onHideTooltip1()"
  >
    <div class="main-container">
      <div class="job-detail-tooltip-header ppp__header">
        <div class="job-detail-tooltip-title"><a [routerLink]="['/punching/patterns', patternId]">Pattern: {{ pattern.patternName }}</a></div>
        @if (visualizeContext) {
        <button
          mat-icon-button
          class="ppp__visualize-btn"
          matTooltip="Visualize with this line's tooling, material, and length"
          (click)="openVisualize()"
        >
          <mat-icon>visibility</mat-icon>
        </button>
        }
      </div>
      <mat-tab-group
        class="main-color-tab"
        [dynamicHeight]="true"
        [selectedIndex]="1"
        [stretchTabs]="true"
      >
        <mat-tab label="Pattern">
          <div
            class="mat-typography p-16 flex-container right-padding-0"
            [style.height]="tableHeight + 'px'"
          >
            <div class="left-container">
              <div class="item-container">
                <div class="item-title"><span translate="punchCount"></span>:</div>
                <div class="item-content">{{ pattern.punches.length }}</div>
              </div>
              <div class="item-container">
                <div class="item-title">
                  <span translate="defaultLength"></span> ({{ 'in' | userDisplayUnits : true }}):
                </div>
                <div class="item-content">{{ pattern.defaultLength }}</div>
              </div>
              <div class="item-container">
                <div class="item-title"><span translate="created"></span>:</div>
                <div class="item-content">{{ pattern.importDate | date : 'MM/dd/yyyy' }}</div>
              </div>
              <div class="item-container">
                <div class="item-title"><span translate="lastUsed"></span>:</div>
                <div class="item-content">{{ pattern.lastUsedDate | date : 'MM/dd/yyyy' }}</div>
              </div>
            </div>
            <div class="right-container">
              <div class="item-container">
                <div class="item-content">
                  <mat-checkbox
                    class="yellow-checkbox"
                    aria-label="check"
                    [(ngModel)]="pattern.isMacro"
                    ngDefaultControl
                    [disabled]="true"
                  >
                    <span translate="patternMacro"></span>
                  </mat-checkbox>
                </div>
              </div>
              <div class="item-container">
                <div class="item-content">
                  <mat-checkbox
                    class="yellow-checkbox"
                    aria-label="check"
                    [(ngModel)]="pattern.isPermanent"
                    ngDefaultControl
                    [disabled]="true"
                  >
                    <span translate="permanent"></span>
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Punches">
          <div
            class="mat-typography p-16 bp-0 job-detail-scroll-container"
            [style]="tableHeight + 'px'"
          >
            <table class="table-container">
              <tr>
                @for (col of punchColumns; track $index) {
                <th class="job-detail-col-item job-detail-col-item-header">
                  <span>{{ col.displayName | translate }}</span>
                </th>
                }
              </tr>
              @for (item of pattern.punches; track trackByKey($index, item)) {
              <tr class="hover order-detail-item">
                @for (col of punchColumns; track $index) {
                <td class="job-detail-col-item">
                  @if (col.field != 'toolId') {
                  <span>{{ item[col.field] }}</span>
                  } @if (col.field == 'toolId') { @switch (item.idType) { @case ('Shape') {
                  <span>{{ item.shapeCode }}</span>
                  } @case ('Macro') {
                  <span>{{ item.macroPatternName }}</span>
                  } @case ('ShapeMacro') {
                  <span>{{ item.macroPatternName }}</span>
                  } @default {
                  <span>{{ item.toolId }}</span>
                  } } }
                </td>
                }
              </tr>
              }
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  }
</ng-template>
